export default "__VITE_ASSET__BO62oSiW__"